import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import localeData from 'dayjs/plugin/localeData'
import relativeTime from 'dayjs/plugin/relativeTime'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/th'
import 'dayjs/locale/en'
import 'dayjs/locale/zh-cn'
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(localeData)
dayjs.extend(relativeTime)
dayjs.extend(localizedFormat)

const momenttimethai = (data) => {
  return (dayjs(data).tz('Pacific/Kiritimati').locale('th').format('LT'))
}
const momentdatethai = (data) => {
  return dayjs(data).add(543, 'year').tz('Pacific/Kiritimati').locale('th').format('ll')
}

const momentdateen = (data) => {
  return dayjs(data).tz('Pacific/Kiritimati').locale('en').format('ll')
}
const momentdatecn = (data) => {
  return dayjs(data).tz('Pacific/Kiritimati').locale('zh_cn').format('ll')
}

const momenttimethaiformnow = (data) => {
  return dayjs(dayjs(data).add(7, 'hour').tz('Pacific/Kiritimati').format().replace(/T/g, ' '), 'YYYY-MM-DD h:mm:ss').locale('th').fromNow()
}

const momenttimethaiformnowcn = (data) => {
  return dayjs(dayjs(data).add(7, 'hour').tz('Pacific/Kiritimati').format().replace(/T/g, ' '), 'YYYY-MM-DD h:mm:ss').locale('zh_cn').fromNow()
}

const momenttimethaiformnowen = (data) => {
  return dayjs(dayjs(data).add(7, 'hour').tz('Pacific/Kiritimati').format().replace(/T/g, ' '), 'YYYY-MM-DD h:mm:ss').fromNow()
}

const momenttimestamp = () => {
  return ((dayjs().tz('America/Danmarkshavn').format()).replace(/T/g, ' ')).replace('Z', '')
}

const momentdatetimethai = (data) => {
  return dayjs(data).tz('Asia/Bangkok').locale('th').format('llll').split('เวลา')[0]
}


const momentCreateDate = () => {
  return ((dayjs().tz('Asia/Bangkok').locale('th').format()).replace(/T/g, ' ')).replace('Z', '')
}

export default {
  momenttimethai,
  momentdatethai,
  momenttimethaiformnow,
  momenttimethaiformnowcn,
  momenttimethaiformnowen,
  momenttimestamp,
  momentdatetimethai,
  momentdateen,
  momentdatecn,
  momentCreateDate
}



// WEBPACK FOOTER //
// ./src/services/momentthai.js